(function (window, document) {

    function luhnMod10(number) {
        var factor = 1, sum = 0, i, addend;
        for (i = number.length - 1; i >= 0; i--) {
            addend = factor * parseInt(number.substr(i, 1), 10);
            factor = factor === 2 ? 1 : 2;
            sum += parseInt((addend / 10) + (addend % 10), 10);
        }
        return sum % 10 === 0;
    }
    
    function validatePersonalIdentityNumber(number, format) {
        if (typeof number !== 'string') {
            return false;
        }
        var n = number.replace(/\D/g, '');
        if (!(n.length === 12 || n.length === 10) || luhnMod10(n.substr(n.length - 10, 10)) === false) {
            return false;
        }
        var months = { 1: 31, 2: 29, 3: 31, 4: 30, 5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31 },
            month = parseInt(n.substr(n.length - 8, 2), 10),
            day = parseInt(n.substr(n.length - 6, 2), 10);
        if ((month < 1 || month > 12) || (day < 1 || day > months[month])) {
            return false;
        }
        var now = new Date(),
            y = now.getFullYear(),
            sep = number.substr(-5, 1) === '+' ? '+' : '-';
        if (n.length === 10) {
            var input_year = parseInt(n.substr(0, 2), 10),
                century = parseInt(y.toString().substr(0, 2), 10),
                year_2di = parseInt(y.toString().substr(2, 2), 10);
            century -= input_year > year_2di ? 1 : 0;
            century -= sep === '+' ? 1 : 0;
            n = century.toString().concat(n);
        }
        switch (format) {
            case 'SHORT':
                return n.substr(2, 6) + sep + n.substr(-4, 4);
            case 'LONG':
                return n.substr(0, 8) + sep + n.substr(-4, 4);
            default:
                return n;
        }
    }
    
    function validateCellPhoneNumber(number) {
        if (typeof number !== 'string') {
            return false;
        }
        return /^(\+46|0)7\d{8}$/.test(number);
    }
    
    function validateEmail(email) {
        if (typeof email !== 'string') {
            return false;
        }
        var emailReg = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return emailReg.test(email);
    }

    function validateRequired(value) {
        return !!value;
    }

    function addValidation(el, validationFn) {
        var errorEl = document.querySelector('[data-valmsg-for="' + el.name + '"]');
        function validate(markAsDirty = false) {
            const value = el.type == "checkbox" ? el.checked : el.value;
            var validationResult = validationFn(value);
            const isValid = typeof validationResult == 'boolean' ? validationResult : validationResult.isValid;
            const customErrorMessage = typeof validationResult == 'object' ? validationResult.errorMessage : null;
            
			if (errorEl) {
				if (!isValid) {
                    el.classList.add('has-error');
                    errorEl.classList.add('has-error');
                    var msg = customErrorMessage || el.getAttribute('data-val-error-message') || el.getAttribute('data-val-regex') || el.getAttribute('data-val-email') || el.getAttribute('data-val-required');
                    errorEl.textContent = msg;
				}
				else {
                    el.classList.remove('has-error');
                    errorEl.classList.remove('has-error');
					errorEl.textContent = "";
				}
            }
            if (markAsDirty) {
                el.classList.add('dirty');
                if (errorEl) {
                    errorEl.classList.add('dirty');
                }
            }
            return validationResult;
        }

        el.lbsValidate = validate;

		el.addEventListener('blur', function(evt) {
			validate(true);
		});

        el.addEventListener('input', function (evt) {
            if (el.classList.contains('dirty')) {
                validate();
            }
        });

        return validate;
	}

	function addCellphoneValidation(el) {
        if (el) {
            el.addEventListener('keypress', function (evt) {
                var isTextSelected = evt.target.selectionEnd != null && evt.target.selectionStart != null && evt.target.selectionEnd - evt.target.selectionStart > 0;
                if (!isTextSelected) {
                    const maxLength = evt.target.value.indexOf('+') == 0 ? 12 : 10;

                    if (evt.target.value.length >= maxLength) {
                        evt.preventDefault();
                    }
                }                
            })
            return addValidation(el, validateCellPhoneNumber);
        }
	}

	function addEmailValidation(el) {
        if (el) {
            return addValidation(el, validateEmail);
        }
    }

    function addRequiredValidation(el) {
        if (el) {
            return addValidation(el, validateRequired);
        }
    }
    
    function personalNumberLiveFormatter(inputEl, errorMessageEl) {
        if (!inputEl) {
            return;
        }
        inputEl.setAttribute('maxlength', '13');

        inputEl.addEventListener('keydown', function (evt) {
            
            if ((evt.which >= 46 && evt.which <= 57) || ((evt.which >= 96 && evt.which <= 105))) {
                var value = inputEl.value;
                var birthYear = parseInt(value);
                if (value.length === 2 &&
                    birthYear !== NaN &&
                    birthYear !== 19 &&
                    birthYear !== 20) {
                    if (birthYear > 9) {
                        inputEl.value = '19' + birthYear
                    } else {
                        inputEl.value = '200' + birthYear
                    }
                }
                if (value.length === 8) {
                    inputEl.value = inputEl.value + '-';
                }
            }
            
            
        });

        addValidation(inputEl, value => validatePersonalIdentityNumber(value, 'LONG') != false);
    }

    function setValidationClasses(el, isValid, markAsDirty) {
        if (!isValid) {
            el.classList.add('has-error');
        }
        else {
            el.classList.remove('has-error');
        }
        if (markAsDirty) {
            el.classList.add('dirty');
        }
    }

    var app = window.LBSApp = window.LBSApp || {};
    app.Validations = {
        addValidation: addValidation,
        validatePersonalIdentityNumber: validatePersonalIdentityNumber,
        validateCellPhoneNumber: validateCellPhoneNumber,
        validateEmail: validateEmail,
        validateRequired: validateRequired,
        addCellphoneValidation: addCellphoneValidation,
        addEmailValidation: addEmailValidation,
        addRequiredValidation: addRequiredValidation,
        personalNumberLiveFormatter: personalNumberLiveFormatter,
        setValidationClasses: setValidationClasses
    }
    
})(window, document)

